import Vue from "vue";
import moment from 'moment'
import {addTrackInfo} from "@/api/track"
import util from '@/utils/util'
Vue.directive("tracking", {
    bind(el, binding) {
        el.binding = binding;
        el.addEventListener("click", async () => {
            let binding = el.binding;
            let val = binding.value;
            let time = moment().format("YYYY-MM-DD HH:mm:ss");
            let userInfo = util.getUserInfo();
            let temp = {
                ...userInfo,
                clickTime: time,
                remark: val.remark,
                eventName: val.actionName,
                eventCode: val.actionCode,
                eventType: '点击事件',
                eventTypeCode: 1,
                moduleType: val.module,
            }
            // console.log(temp)
            await addTrackInfo(temp);

        })
    },
    update(el, binding) {
        el.binding = binding;
    }
})
